import { IcoImage } from "../icons";

type OrgNameHeaderProps = {
  orgId: string;
  orgName: string;
  logoUrl?: string | null;
};

export function OrgNameHeader({ orgId, orgName, logoUrl }: OrgNameHeaderProps) {
  return (
    <a
      href={`/orgs/${orgId}`}
      class="flex items-center gap-4 hover:opacity-80 transition-opacity"
    >
      <div class="size-10 rounded-lg bg-surface-muted flex items-center justify-center overflow-hidden flex-shrink-0">
        {logoUrl ? (
          <img src={logoUrl} alt={orgName} class="size-full object-cover" />
        ) : (
          <IcoImage class="size-5 text-text-muted" />
        )}
      </div>
      <span class="text-2xl font-bold text-text">{orgName}</span>
    </a>
  );
}
